export function getEnv() {
    const envLocation = window.location.origin;

    console.log('Checking environment:', envLocation);

    switch (envLocation) {
        case "http://localhost:3000":
            return {
                KEYCLOAK_CLIENT_SECRET: 'zMKU0K4AANupRpu6N5OzofDvkkvYaEU3',
                KEYCLOAK_CLIENT_ID: 'lyfetravellerClient',
                // PRINT_URL: 'http://localhost:5001/SwasthaPrint/',
                ENDPOINT: 'https://lyfe-traveller.com/',
                KEYCLOAK: 'https://lyfe-traveller.com/',
            };

        case "https://lyfe-traveller.com":
            return {
                KEYCLOAK_CLIENT_SECRET: 'zMKU0K4AANupRpu6N5OzofDvkkvYaEU3',
                KEYCLOAK_CLIENT_ID: 'lyfetravellerClient',
                ENDPOINT: 'https://lyfe-traveller.com/',
                KEYCLOAK: 'https://lyfe-traveller.com/',
            };

        default:
            return {
                KEYCLOAK_CLIENT_SECRET: 'zMKU0K4AANupRpu6N5OzofDvkkvYaEU3',
                KEYCLOAK_CLIENT_ID: 'lyfetravellerClient',
                // PRINT_URL: 'http://20.84.115.205/SwasthaPrint/',
                ENDPOINT: 'https://lyfe-traveller.com/',
                KEYCLOAK: 'https://lyfe-traveller.com/',
                // SWASTHSA_COMMON_LOGIN_VIEW: true
            };
    }
}
